/**
 * Stack routes of the native screens added by the `service` admin-module group.
 * Registered by AppNavigator in the management stack.
 */
import lazyScreen from '../../components/lazyScreen';

const ROUTES = [
    // Generic config-driven list (route param `kind`, see screens/adminModules/service/serviceListKinds.js).
    {name: 'ServiceListScreen', component: lazyScreen(() => import('../../screens/adminModules/service/ServiceListScreen'))},
    {name: 'ServiceWorkflowsScreen', component: lazyScreen(() => import('../../screens/adminModules/service/ServiceWorkflowsScreen'))},
    // Fleet GPS: live map of all tracked vehicles + per-vehicle movement history (track playback).
    {name: 'FleetLiveMapScreen', component: lazyScreen(() => import('../../screens/adminModules/service/FleetLiveMapScreen'))},
    {name: 'FleetVehicleHistoryScreen', component: lazyScreen(() => import('../../screens/adminModules/service/FleetVehicleHistoryScreen'))},
    {name: 'ServiceCalculatorScreen', component: lazyScreen(() => import('../../screens/adminModules/service/ServiceCalculatorScreen'))},
    // Same generic settings form as the warehouse group (HACCP / service settings), registered under its own name.
    {name: 'ServiceSettingsFormScreen', component: lazyScreen(() => import('../../screens/adminModules/warehouse/SettingsFormScreen'))},
];

export default ROUTES;
